export enum ServiceNames {
    Autoalign = "3D auto align",
    PressurePlateReport = "Pressure plate report",
    OldVersionScan = "Old version",
    BasicScan = "Basic scans",
    AdvancedScan = "Advanced scans",
    ProScan = "Pro scans",
    ProFeatures = "Pro features",
    ThreeDInsolesDesign = "3D design insoles",
    ThreeDAfoDesign = "3D design afo",
    ThreeDSpinalBraceDesign = "3D design spinal brace"
}

export enum Roles {
    ROLE_DISTRIBUTOR = "ROLE_DISTRIBUTOR_PROFESSIONAL",
    ROLE_CUSTOMER = "ROLE_CUSTOMER",
    ROLE_FILES_PROCESSOR = "ROLE_CUSTOMER",
    ROLE_INDIVIDUAL_CLIENT = "ROLE_INDIVIDUAL_CLIENT",
    ROLE_ADMIN = "ROLE_ADMIN",
    ROLE_CLINIC_ADMIN = "ROLE_CLINIC_ADMIN",
    ROLE_CLINIC = "ROLE_CLINIC",
    ROLE_PRINTING_HUB = "ROLE_3D_PRINTING_HUB",
}

export enum FileTypes {
    plantarSurface = "plantarSurface",
    foam = "foam",
    foot = "foot",
    leg = "leg",
    torso = "torso",
    face = "face"
}

export enum ScanModes {
    weighted = "weighted",
    semiWeighted = "semi-weighted",
    nonWeighted = "non-weighted",
    foambox = "foambox"
}

export enum ScanType {
    foot = "foot",
    foam = "foam",
    dualFoam = "dualFoam",
    plantarSurface = "plantarSurface",
    torso = "torso",
    leg = "leg"
}